import CustomError from "@components/Error/CustomError";
import { TRouteWithRedirect, useRouteContext } from "@sphtech/web2-core/ssr";

const StoryQueuePage = (): React.ReactElement => {
  const { context } = useRouteContext<TRouteWithRedirect<string, string>>();

  return <CustomError statusCode={context.statusCode} />;
};

export default StoryQueuePage;
